import { useEffect, useState } from "react";

export function useServiceWorkerUpdater() {
    const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

    useEffect(() => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.addEventListener("controllerchange", () => {
                window.location.reload();
            });

            navigator.serviceWorker.ready.then((registration) => {
                registration.addEventListener("updatefound", () => {
                    const newWorker = registration.installing;
                    if (newWorker) {
                        newWorker.addEventListener("statechange", () => {
                            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                                setWaitingWorker(newWorker);
                                setIsUpdateAvailable(true);
                            }
                        });
                    }
                });
            });
        }
    }, []);

    const updateApp = () => {
        if (waitingWorker) {
            waitingWorker.postMessage({ type: "SKIP_WAITING" });
        }
    };

    return { isUpdateAvailable, updateApp };
}
